module.exports = __webpack_public_path__ + "img/symbol_9.51d49334.png";